import { createBrowserHistory } from "history";
import * as queryString from "query-string";
import { generalStore } from "../../../stores/GeneralStore";

export const history = createBrowserHistory({ basename: process.env.REACT_APP_BASE_NAME || "/" });

export function withQuery(route: string, params: { [key: string]: any }) {
    const query = queryString.stringify(params);
    return route + "?" + query;
}

export function withParams(route: string, params: { [key: string]: string }) {
    const routeParams = route.split("/").filter((component) => component.startsWith(":"));
    const paramKeys = Object.keys(params);
    // Look for params that are not defined in the route params
    const notFound = paramKeys.filter((key) => routeParams.indexOf(":" + key) < 0);
    if (notFound.length > 0) {
        throw new Error(`Invalid URL parameters "${notFound}" for route "${route}". Maybe a typo?`);
    }

    return paramKeys.reduce((url, key) => url.replace(`:${key}`, params[key]), route);
}

// Not unified as optional parameter to e.g. withParams to allow for better searchability
export function withParamsAndQuery(route: string, params: { [key: string]: string }, query: { [key: string]: any }) {
    return withParams(withQuery(route, query), params);
}

interface IRouteOptions {
    params?: { [key: string]: string };
    query?: { [key: string]: any };
    state?: any;
}

export function pushRoute(route: string, options?: IRouteOptions) {
    let url = route;
    if (options?.params) {
        url = withParams(url, options.params);
    }
    if (options?.query) {
        url = withQuery(url, options.query);
    }

    // debug.log("### pushRoute", url);
    history.push(url, options?.state);
}

export function goBack(fallbackRoute: string, options?: IRouteOptions) {
    if (generalStore.lastLocation) {
        history.goBack();
    } else {
        pushRoute(fallbackRoute, options);
    }
}
